import { put, takeEvery } from "redux-saga/effects";
import { SET_FILTER, REMOVE_FILTER } from './filterSlice';
import { setFilterSuccess, setFilterError, removeFilterSuccess, removeFilterError } from './filterAction';

// Worker saga for setting filter
function* setFilterSaga(action) {
  try {
    console.log('Saga received action:', action);
    
    const { groups, search, refid, voucherChange, dateFrom, dateTo, productData, accData } = action.payload;
    console.log('Setting filter - groups:', groups, 'search:', search);
    
    // Just dispatch success - no localStorage operations
    yield put(setFilterSuccess({ groups, search, refid, voucherChange, dateFrom, dateTo, productData, accData }));
    
  } catch (error) {
    console.error('Error setting filter:', error);
    yield put(setFilterError(error.message));
  }
}

// Worker saga for removing filter
function* removeFilterSaga() {
  try {
    // Just dispatch success - no localStorage operations
    yield put(removeFilterSuccess());
  } catch (error) {
    console.error('Error removing filter:', error);
    yield put(removeFilterError(error.message));
  }
}

// Watcher saga
export function* watchFilterSaga() {
  yield takeEvery(SET_FILTER, setFilterSaga);
  yield takeEvery(REMOVE_FILTER, removeFilterSaga);
}